// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__1xRhP","green":"Badge_green__IDWke","orange":"Badge_orange__S4gdP","red":"Badge_red__PDDZR","blue":"Badge_blue__7rp90","gray":"Badge_gray__0II1N"};